import type { VoidFunctionComponent } from 'react';
import { plural } from '../../../../../shared/helpers';
import type { Project } from '../../../../../shared/issuesV2';

type ProjectsListProps = {
  projects: Project[];
};

/**
 *  Lists the projects in which the issue appears.
 */
const ProjectsList: VoidFunctionComponent<ProjectsListProps> = ({ projects }) => (
  <div className="issue-item__project-list">
    <span>{`${plural(projects.length, 'Project')} (${projects.length.toLocaleString()})`}</span>
  </div>
);

export default ProjectsList;
